/**
 * Malachyte Analytics Client ID Tracker
 * 
 * This script captures the Shopify Analytics clientId from the Shopify analytics API
 * and stores it in localStorage for use with Malachyte personalization API.
 * 
 * Usage: Include this script in your theme and it will automatically track the clientId.
 */

(function() {
  'use strict';
  
  /**
   * Get the Shopify Analytics Client ID
   * This uses the Shopify analytics API if available
   */
  function getMalachyteClientId() {
    try {
      // Check if Shopify analytics is available
      if (window.Shopify && window.Shopify.analytics) {
        // Try to get the clientId from Shopify analytics
        if (window.Shopify.analytics.replayQueue) {
          // Look for page_viewed event in the replay queue
          const pageViewedEvents = window.Shopify.analytics.replayQueue.filter(
            event => event && event.eventName === 'page_viewed'
          );
          
          if (pageViewedEvents.length > 0) {
            const latestEvent = pageViewedEvents[pageViewedEvents.length - 1];
            if (latestEvent.payload && latestEvent.payload.clientId) {
              return latestEvent.payload.clientId;
            }
          }
        }
        
        // Alternative: Try to access from Shopify.analytics directly
        if (window.Shopify.analytics.clientId) {
          return window.Shopify.analytics.clientId;
        }
      }
      
      // Fallback: Check if it's already stored
      const storedId = localStorage.getItem('_malachyte_id');
      if (storedId) {
        return storedId;
      }
      
      return null;
    } catch (error) {
      console.error('[Malachyte] Error getting clientId:', error);
      return null;
    }
  }
  
  /**
   * Store the clientId in localStorage
   */
  function storeMalachyteClientId(clientId) {
    try {
      if (clientId && typeof localStorage !== 'undefined') {
        localStorage.setItem('_malachyte_id', clientId);
        console.log('[Malachyte] Client ID stored:', clientId);
        return true;
      }
      return false;
    } catch (error) {
      console.error('[Malachyte] Error storing clientId:', error);
      return false;
    }
  }
  
  /**
   * Initialize the tracker
   */
  function initMalachyteTracker() {
    // Try immediately
    const clientId = getMalachyteClientId();
    if (clientId) {
      storeMalachyteClientId(clientId);
      return;
    }
    
    // If not available, set up a polling mechanism to check periodically
    let attempts = 0;
    const maxAttempts = 10;
    const pollInterval = 500; // Check every 500ms
    
    const poller = setInterval(() => {
      attempts++;
      const clientId = getMalachyteClientId();
      
      if (clientId) {
        storeMalachyteClientId(clientId);
        clearInterval(poller);
      } else if (attempts >= maxAttempts) {
        console.warn('[Malachyte] Could not retrieve Shopify Analytics clientId after', attempts, 'attempts');
        clearInterval(poller);
      }
    }, pollInterval);
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMalachyteTracker);
  } else {
    initMalachyteTracker();
  }
  
  // Also try on window load as a backup
  window.addEventListener('load', () => {
    const clientId = getMalachyteClientId();
    if (clientId) {
      storeMalachyteClientId(clientId);
    }
  });
  
  // Expose a global function to retrieve the clientId
  window.getMalachyteClientId = getMalachyteClientId;
  
})();

